import api from './api';
import { LoginResponse } from '../models/LoginResponse.model';
import { LoginRequest } from '../models/LoginRequest.model';

const AUTH_TOKEN_KEY = 'auth_token';

export const authService = {
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/login', credentials);
    // שמירת הטוקן ב-sessionStorage
    sessionStorage.setItem(AUTH_TOKEN_KEY, response.data.token);
    return response.data;
  },

  logout(): void {
    // מחיקת הטוקן מה-sessionStorage
    sessionStorage.removeItem(AUTH_TOKEN_KEY);
  },

  getToken(): string | null {
    return sessionStorage.getItem(AUTH_TOKEN_KEY);
  },

  isAuthenticated(): boolean {
    return !!this.getToken();
  }
};

export default authService;
